export const SEAT_PRICING_INELIGIBILITY = 'seat-pricing-ineligibility';